import React from 'react';
import { Grid, Paper, Box, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import DraftsIcon from '@mui/icons-material/Drafts';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const MetricCard = ({ title, value, icon, color = 'primary.main', subtitle }) => (
  <Paper elevation={2}>
    <Box padding={3}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {title}
          </Typography>
          <Typography variant="h4" fontWeight="bold">
            {value}
          </Typography>
          {subtitle && (
            <Typography variant="caption" color="textSecondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        <Box sx={{ color }}>
          {icon}
        </Box>
      </Box>
    </Box>
  </Paper>
);

export default function EmailMetricCards({ metrics }) {
  const cards = [
    {
      title: 'Total Emails Sent',
      value: metrics.totalSent.toLocaleString(),
      icon: <EmailIcon fontSize="large" />,
      color: '#4A90E2',
      subtitle: `To ${metrics.uniqueRecipients.size} unique recipients`
    },
    {
      title: 'Emails Opened',
      value: metrics.totalOpened.toLocaleString(),
      icon: <DraftsIcon fontSize="large" />,
      color: '#28be5f',
      subtitle: `${metrics.openRate}% open rate`
    },
    {
      title: 'Unopened Emails',
      value: metrics.totalUnopened.toLocaleString(),
      icon: <MarkunreadIcon fontSize="large" />,
      color: '#6b6666',
      subtitle: `${(100 - parseFloat(metrics.openRate)).toFixed(1)}% unopened`
    },
    {
      title: 'Active Vendors',
      value: metrics.vendorMetrics.size,
      icon: <TrendingUpIcon fontSize="large" />,
      color: '#b180d1',
      subtitle: 'With email activity'
    }
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <MetricCard {...card} />
        </Grid>
      ))}
    </Grid>
  );
}